import { render, staticRenderFns } from "./OmniSearch.vue?vue&type=template&id=233f4256&"
import script from "./OmniSearch.vue?vue&type=script&lang=js&"
export * from "./OmniSearch.vue?vue&type=script&lang=js&"
import style0 from "./OmniSearch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports